import { useContextState } from "../../../../../../hooks/theme"

function useStyles() {
    const { colors } = useContextState()
    return {
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            height: '100%', 
        },
        documentsContainer: {
            width: '100%',
            maxHeight: '200px',
            overflowY: 'auto',
            padding: '3px',
            display: 'flex',
            flexWrap: 'wrap',
            rowGap: '10px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: `0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)`,
        },
        documentItems: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            padding: '10px 10px 0px',
            borderRadius: '5px',
            '&:hover': {
                backgroundColor: `${colors.color22}05`,
            },
            '& .MuiIcon-root': {
                color: colors.color1,
                height: '35px',
                width: '35px',
            },
        },
        documentName: {
            width: 'calc(100% - 50px)',
            wordBreak: 'break-word',
        },
        comments: {
            width: '100%',
            maxHeight: '300px',
            overflowY: 'auto',
        },
        paddingComments: {
            padding: '20px 20px 20px 25px',
        },
        buttonState: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        mainContainer: {
            display: 'flex', 
            flexDirection: 'column', 
            height: '100%', 
            border: '1px solid red'
        },
        bodyContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            flex: 1, 
            overflow: 'auto',
            scrollbarWidth: 'none',
            padding: '2px'
        },
    }
}

export { useStyles }